import { Component } from "react";

import { StatsList, StatsItem } from "./Statistics.styled.js";

export class Statistics extends Component {
  render() {
    const { good, neutral, bad, total, positivePercentage } = this.props;
    return (
      <StatsList>
        <StatsItem>Good: {good}</StatsItem>
        <StatsItem>Neutral: {neutral}</StatsItem>
        <StatsItem>Bad: {bad}</StatsItem>
        <StatsItem>Total: {total}</StatsItem>
        <StatsItem>Positive feedback: {positivePercentage}%</StatsItem>
      </StatsList>
    );
  }
}
